import axios, { AxiosInstance } from 'axios';
import { ApiResponse, Project, Scene, ModelAssetDTO } from '../types';
const env = (import.meta as any).env || {};
const API_URL =
  env.VITE_API_URL || 'http://localhost:3000';
const api: AxiosInstance = axios.create({
  baseURL: API_URL,
  timeout: parseInt(env.VITE_API_TIMEOUT || '30000'),
  headers: {
    'Content-Type': 'application/json',
  },
});
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
export const projectAPI = {
  getAll: () => api.get<ApiResponse<Project[]>>('/api/v1/projects'),
  getById: (id: string) =>
    api.get<ApiResponse<Project>>(`/api/v1/projects/${id}`),
  create: (data: Partial<Project>) =>
    api.post<ApiResponse<Project>>('/api/v1/projects', data),
  update: (id: string, data: Partial<Project>) =>
    api.put<ApiResponse<Project>>(`/api/v1/projects/${id}`, data),
  delete: (id: string) =>
    api.delete<ApiResponse<void>>(`/api/v1/projects/${id}`),
  saveScene: (projectId: string, scene: Scene) =>
    api.put<ApiResponse<Project>>(
      `/api/v1/projects/${projectId}/scene`,
      { scene }
    ),
  export: (projectId: string, format: 'web' | 'unity') =>
    api.post<ApiResponse<{ exportUrl: string }>>(
      `/api/v1/projects/${projectId}/export`,
      { format }
    ),
};
export const modelAPI = {
  getAll: () => api.get<ApiResponse<ModelAssetDTO[]>>('/models'),
  // Raw axios (not the shared instance): we must send the admin Bearer token and
  // multipart form data, bypassing the default JSON header and authToken interceptor.
  upload: (formData: FormData, adminToken: string) =>
    axios.post<ApiResponse<ModelAssetDTO>>(`${API_URL}/models`, formData, {
      headers: { Authorization: `Bearer ${adminToken}` },
      timeout: 120000,
    }),
};
export const healthAPI = {
  check: () =>
    api.get<{ status: string; timestamp: string }>('/health'),
};
export default api;
